import UserPrepaidCardApi from '@apis/prepaid/UserPrepaidCardApi';
import { GetPrepaidCardTransactionsParams } from '@models/prepaidCard';
import { useQuery } from '@tanstack/react-query';
import dayjs from 'dayjs';
import { useReducer, useState } from 'react';

export type TransactionParamActionType = 'week' | 'month' | 'quarter' | 'all';

const DATE_FORMAT = 'YYYY-MM-DD';

interface Props {
    id: string;
}

function usePrepaidCardTransactions({ id }:Props) {
    const [period, setPeriod] = useState<Exclude<TransactionParamActionType, 'nextPage'>>('week');
    const to = dayjs().format(DATE_FORMAT);
    const [params, dispatch] = useReducer((state: GetPrepaidCardTransactionsParams, action: TransactionParamActionType) => {
        switch (action) {
        case 'week':
            setPeriod('week');
            return {
                from: dayjs().subtract(1, 'week').format(DATE_FORMAT), to,
            };
        case 'month':
            setPeriod('month');
            return {
                from: dayjs().subtract(1, 'month').format(DATE_FORMAT), to,
            };
        case 'quarter':
            setPeriod('quarter');
            return {
                from: dayjs().subtract(3, 'month').format(DATE_FORMAT), to,
            };
        default:
            setPeriod('all');
            return { };
        }
    }, {
        from: dayjs().subtract(1, 'week').format(DATE_FORMAT), to,
    });
    const { data } = useQuery({
        queryKey: ['prepaidCardTransactions', params],
        queryFn: () => UserPrepaidCardApi.getPrepaidCardTransactions(id, params),
    });
    const transactions = data?.transactions;
    const changePeriod = (type: Exclude<TransactionParamActionType, 'nextPage'>) => {
        dispatch(type);
    };
    return {
        transactions, changePeriod, period,
    };
}

export default usePrepaidCardTransactions;
